exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".address-cell-wrapper[data-v-67af8f72]{display:flex;align-items:center;justify-content:space-between;width:100%;gap:8px}.address-link[data-v-67af8f72]{color:#0b36dc;font-weight:700;cursor:pointer;text-decoration:underline;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex-grow:1}.address-link[data-v-67af8f72]:hover{color:#0056b3}.address-text[data-v-67af8f72]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex-grow:1}.history-btn-custom[data-v-67af8f72]{font-size:11px!important;padding:2px 5px!important}", ""]);

// exports
